/*
 * @author: xd
 * @Date: 2021-12-15 13:03:03
 * @LastEditors: xd
 * @LastEditTime: 2022-06-25 14:12:40
 * @Description: 功能
 */

import { UserInfo } from "../modules/user/userinfo";
import { BaseClass } from "../base/DreamScape";
import axios, { AxiosRequestConfig } from "axios";
import Qs from "qs";
import { Cache } from "./cache";

export interface IActionUploadData {
  xmbh: string;
  file: any;
  [prop: string]: any;
}

export interface IActionData {
  XDLMSID: string;
  XDLMCID: string;
  [prop: string]: any;
}
export interface IActionDelData {
  XDLMSID: string;
  XDLMCID: string;
  XDLMROWID: string;
  [prop: string]: any;
}

export class Axios extends BaseClass {
  userinfo: UserInfo;
  constructor() {
    super();
    this.userinfo = new UserInfo();
  }

  PostData(
    mUrl: string,
    mDataName: string,
    mActionType: string,
    mActionData: IActionData
  ): Promise<any> {
    return this.PostDataA(mUrl,mDataName, mActionType, mActionData);
  }

  uploadData(
    mUrl: string,
    mDataName: string,
    mActionType: string,
    mActionData: IActionUploadData,
    onUploadProgress?: any
  ): Promise<any> {
    return this.uploadDataA(
      mUrl,
      mDataName,
      mActionType,
      mActionData,
      onUploadProgress
    );
  }

  PostDataByID(
    mUrl: string,
    mDataName: string,
    mActionType: string,
    mActionData: IActionData,
    mAppid: string
  ): Promise<any> {
    return this.PostDataA(mUrl,mDataName, mActionType, mActionData, mAppid);
  }

  PostDataA(
    mUrl: string,
    XKLX: string,
    mActionType: string,
    mActionData: IActionData,
    mAppid?: string
  ): Promise<any> {
    mActionData.XAction = mActionType;
    mActionData.XKLX = XKLX;

    // axios.defaults.headers.post["Content-Type"] =
    //   "application/x-www-form-urlencoded"; //;charset=UTF-8

    // 创建axios实例
    var instance = axios.create({
      timeout: 10000 * 12,
    });

    if (mAppid) {
      mActionData.XKLX_APPID = mAppid;
    } else {
      let aa = this.userinfo.GetSysToken();
      if (aa) {
        instance.defaults.headers.common["Authorization"] =
          Cache.GetCookieName("sytoken");
        // instance.defaults.headers.get["Authorization"] =
        // this.userinfo.GetSysToken();
      }
    }

    /**
     * 请求拦截器
     * 每次请求前，如果存在token则在请求头中携带token
     */
    instance.interceptors.request.use(
      (config) => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        if (mAppid) {
          mActionData.XKLX_APPID = mAppid;
        } else {
          let aa = this.userinfo.GetSysToken();
          if (aa) {
            if (config.headers) {
              //config.headers.common.Authorization = this.userinfo.GetSysToken();
              config.headers.Authorization = Cache.GetCookieName("sytoken");
              //config.headers.get.Authorization =
              //this.userinfo.GetSysToken();
            }
          }
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    // 响应拦截器
    // instance.interceptors.response.setCharacterEncoding( "UTF-8");
    // instance.interceptors.response.setContentType( "application/json; charset=utf-8")
    instance.interceptors.response.use(
      // 请求成功
      (res) => {
        if (res.data) {
          if (res.data.message == "NOTLOGIN") {
            localStorage.removeItem("sytoken");
            Cache.DelCookie("sytoken");
          }
          if (res.data.message == "登陆成功") {
            Cache.DelCookie("mUserName");
            Cache.DelCookie("xmbh");
            Cache.DelCookie("sytoken");
            Cache.DelCookie("mUserID");

            Cache.SetCookie("xmbh", "", "h8");
            Cache.SetCookie("mUserID", res.data.data[0].mUserID, "h8");
            Cache.SetCookie("mUserName", res.data.data[0].mUserName, "h8");
            Cache.SetTokenCookie("sytoken", res.data.sytoken, "h8");
          }
        }
        return res.status === 200
          ? Promise.resolve(res.data)
          : Promise.reject({ success: false, message: res.data });
      },
      // 请求失败
      (error) => {

        if (error) {
          if (error.message == "Network Error") {
            return Promise.reject({
              success: false,
              message: "网络连接失败",
            });
          } else {
            // 请求已发出，但是不在2xx的范围
            errorHandle(error.status, error.message);
            return Promise.reject({
              success: false,
              error: error,
              message: error.message,
            });
          }
        } else {
          // 处理断网的情况
          // eg:请求超时或断网时，更新state的network状态
          // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
          // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
          // store.commit('changeNetwork', false);
          return Promise.reject({ success: false, message: error });
        }
      }
    );

    // 设置post请求头

    /**
     * 请求失败后的错误统一处理
     * @param {Number} status 请求失败的状态码
     */
    const errorHandle = (status: any, other: any) => {
      // 状态码判断

      switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
          // toLogin();
          break;
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
          // tip('登录过期，请重新登录');
          localStorage.removeItem("sytoken");
          Cache.DelCookie("sytoken");
          // store.commit('loginSuccess', null);
          // setTimeout(() => {
          //     toLogin();
          // }, 1000);
          break;
        // 404请求不存在
        case 404:
          //  tip('请求的资源不存在');
          break;
        default:
          console.log(other);
      }
    };

    let parameter: AxiosRequestConfig = {};

    if (mActionData.XDLMCID) {
      if (
        mActionData.XDLMCID == "5000" ||
        mActionData.XDLMCID == "5001" ||
        mActionData.XDLMCID == "4000" ||
        mActionData.XDLMCID == "6000" ||
        mActionData.XDLMCID == "9000"
      ) {
        parameter = this.getUrlParameter(
          "POST",
          mUrl + "/xdData/xdDataManage.ashx",
          mActionData,
          {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8;",
          }
        );
      } else {
        parameter = this.getUrlParameter(
          "GET",
          mUrl + "/xdData/xdDataManage.ashx",
          mActionData,
          {
            "Content-Type": "application/json;charset=utf-8;",
            "X-Requested-With": "XMLHttpRequest",
          }
        );
      }
    } else {
      parameter = this.getUrlParameter(
        "GET",
        mUrl + "/xdData/xdDataManage.ashx",
        mActionData,
        {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        }
      );
    }
    return instance(parameter);
    // return axios.get(mUrl + "/xdData/xdDataManage.ashx", {
    //   // `url` 是用于请求的服务器 URL
    //   //url: '/user',

    //   // `method` 是创建请求时使用的方法
    //   method: "get", // 默认是 get

    //   // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
    //   // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
    //   //baseURL: 'https://some-domain.com/api/',

    //   // `transformRequest` 允许在向服务器发送前，修改请求数据
    //   // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
    //   // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream
    //   transformRequest: [
    //     function (data) {
    //       // 对 data 进行任意转换处理
    //       return data;
    //     },
    //   ],
    //   // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
    //   transformResponse: [
    //     function (data) {
    //       // 对 data 进行任意转换处理
    //       return data;
    //     },
    //   ],

    //   // `headers` 是即将被发送的自定义请求头
    //   headers: { "Content-Type": "application/json" },

    //   // `params` 是即将与请求一起发送的 URL 参数
    //   // 必须是一个无格式对象(plain object)或 URLSearchParams 对象
    //   params: mActionData,
    //   // `paramsSerializer` 是一个负责 `params` 序列化的函数
    //   // (e.g. https://www.npmjs.com/package/qs, http://api.jquery.com/jquery.param/)
    //   paramsSerializer: function (params) {
    //     debugger;
    //     return Qs.stringify(params);
    //   },

    //   // `data` 是作为请求主体被发送的数据
    //   // 只适用于这些请求方法 'PUT', 'POST', 和 'PATCH'
    //   // 在没有设置 `transformRequest` 时，必须是以下类型之一：
    //   // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    //   // - 浏览器专属：FormData, File, Blob
    //   // - Node 专属： Stream
    //   // data: {
    //   //   firstName: 'Fred'
    //   // },

    //   // `timeout` 指定请求超时的毫秒数(0 表示无超时时间)
    //   // 如果请求话费了超过 `timeout` 的时间，请求将被中断
    //   timeout: 10000000,

    //   // `withCredentials` 表示跨域请求时是否需要使用凭证
    //   withCredentials: false, // 默认的

    //   // `adapter` 允许自定义处理请求，以使测试更轻松
    //   // 返回一个 promise 并应用一个有效的响应 (查阅 [response docs](#response-api)).
    //   // adapter: function (config) {
    //   //   /* ... */
    //   // },

    //   // `auth` 表示应该使用 HTTP 基础验证，并提供凭据
    //   // 这将设置一个 `Authorization` 头，覆写掉现有的任意使用 `headers` 设置的自定义 `Authorization`头
    //   // auth: {
    //   //   username: 'janedoe',
    //   //   password: 's00pers3cret'
    //   // },

    //   // `responseType` 表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
    //   responseType: "json", // 默认的

    //   // `xsrfCookieName` 是用作 xsrf token 的值的cookie的名称
    //   // xsrfCookieName: 'XSRF-TOKEN', // default

    //   // `xsrfHeaderName` 是承载 xsrf token 的值的 HTTP 头的名称
    //   // xsrfHeaderName: 'X-XSRF-TOKEN', // 默认的

    //   // `onUploadProgress` 允许为上传处理进度事件
    //   onUploadProgress: function (progressEvent) {
    //     // 对原生进度事件的处理
    //   },

    //   // `onDownloadProgress` 允许为下载处理进度事件
    //   onDownloadProgress: function (progressEvent) {
    //     // 对原生进度事件的处理
    //   },

    //   // `maxContentLength` 定义允许的响应内容的最大尺寸
    //   maxContentLength: 20000000000,

    //   // `validateStatus` 定义对于给定的HTTP 响应状态码是 resolve 或 reject  promise 。如果 `validateStatus` 返回 `true` (或者设置为 `null` 或 `undefined`)，promise 将被 resolve; 否则，promise 将被 rejecte
    //   validateStatus: function (status) {
    //     return status >= 200 && status < 300; // 默认的
    //   },

    //   // `maxRedirects` 定义在 node.js 中 follow 的最大重定向数目
    //   // 如果设置为0，将不会 follow 任何重定向
    //   //maxRedirects: 5, // 默认的

    //   // `httpAgent` 和 `httpsAgent` 分别在 node.js 中用于定义在执行 http 和 https 时使用的自定义代理。允许像这样配置选项：
    //   // `keepAlive` 默认没有启用
    //   // httpAgent: new http.Agent({ keepAlive: true }),
    //   // httpsAgent: new https.Agent({ keepAlive: true }),

    //   // 'proxy' 定义代理服务器的主机名称和端口
    //   // `auth` 表示 HTTP 基础验证应当用于连接代理，并提供凭据
    //   // 这将会设置一个 `Proxy-Authorization` 头，覆写掉已有的通过使用 `header` 设置的自定义 `Proxy-Authorization` 头。
    //   // proxy: {
    //   //   host: '127.0.0.1',
    //   //   port: 9000,
    //   //   auth: : {
    //   //     username: 'mikeymike',
    //   //     password: 'rapunz3l'
    //   //   }
    //   // },

    //   // `cancelToken` 指定用于取消请求的 cancel token
    //   // （查看后面的 Cancellation 这节了解更多）
    //   // cancelToken: new CancelToken(function (cancel) {
    // });
    // }
  }

  getUrlParameter(method: any, url: string, params: any, headers: any) {
    let parameter: AxiosRequestConfig = {
      url: url,
      headers: headers,
      timeout: 10000 * 12,
      maxContentLength: 20000000000,
      method: method, // 默认是 get
      responseType: "json",
      params: method === "GET" || method === "DELETE" ? params : null,
      data: method === "POST" || method === "PUT" ? Qs.stringify(params) : null,

      // `transformRequest` 允许在向服务器发送前，修改请求数据
      // 只能用在 'PUT', 'POST' 和 'PATCH' 这几个请求方法
      // 后面数组中的函数必须返回一个字符串，或 ArrayBuffer，或 Stream

      // transformRequest: [
      //   function (data) {
      //     // 对 data 进行任意转换处理
      //     return data;
      //   },
      // ],
      // // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
      // transformResponse: [
      //   function (data) {
      //     // 对 data 进行任意转换处理,打开后会默认成字符串 必须做格式转换
      //     return JSON.parse(data);
      //   },
      // ],
    };
    return parameter;
  }

  uploadDataA(
    mUrl: string,
    XKLX: string,
    mActionType: string,
    mActionData: IActionUploadData,
    mUploadProgress?: any
  ): Promise<any> {
    mActionData.XAction = mActionType;
    mActionData.XKLX = XKLX;

    if (!mActionData.XKLX_APPID) {
      if (!this.userinfo.GetSysToken()) {
        return Promise.reject({
          success: false,
          message: "缺少appid或appkey",
        });
      }
      axios.defaults.headers.common["Authorization"] =
        this.userinfo.GetSysToken();
    }

    let mConfig: AxiosRequestConfig = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      transformRequest: [
        function (data) {
          return data;
        },
      ],
      onUploadProgress: (progressEvent) => {
        mUploadProgress(
          ((progressEvent.loaded / progressEvent.total) * 100) | 0
        );
        //let persent = (progressEvent.loaded / progressEvent.total * 100 | 0)		//上传进度百分比
        //console.log(persent)
      },
    };

    // 创建axios实例
    var instance = axios.create({ timeout: 10000 * 12 });
    // 设置post请求头
    instance.defaults.headers.post["Content-Type"] = "multipart/form-data";

    /**
     * 请求失败后的错误统一处理
     * @param {Number} status 请求失败的状态码
     */
    const errorHandle = (status: any, other: any) => {
      // 状态码判断

      switch (status) {
        // 401: 未登录状态，跳转登录页
        case 401:
          // toLogin();
          break;
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
          // tip('登录过期，请重新登录');
          localStorage.removeItem("sytoken");
          Cache.DelCookie("sytoken");

          break;
        // 404请求不存在
        case 404:
          //  tip('请求的资源不存在');
          break;
        default:
          console.log(other);
      }
    };

    /**
     * 请求拦截器
     * 每次请求前，如果存在token则在请求头中携带token
     */
    instance.interceptors.request.use(
      (config) => {
        // 登录流程控制中，根据本地是否存在token判断用户的登录情况
        // 但是即使token存在，也有可能token是过期的，所以在每次的请求头中携带token
        // 后台根据携带的token判断用户的登录情况，并返回给我们对应的状态码
        // 而后我们可以在响应拦截器中，根据状态码进行一些统一的操作。
        //const token = store.state.token;
        // token && (config.headers.Authorization = token);
        if (!mActionData.XKLX_APPID) {
          if (config.headers) {
            config.headers.Authorization = this.userinfo.GetSysToken();
          }
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // 响应拦截器
    instance.interceptors.response.use(
      // 请求成功
      (res) => {
        if (res.data) {
          if (res.data.message == "NOTLOGIN") {
            localStorage.removeItem("sytoken");
            Cache.DelCookie("sytoken");
          }
        }
        return res.status === 200
          ? Promise.resolve(res.data)
          : Promise.reject({ success: false, message: res.data });
      },
      // 请求失败
      (error) => {
        if (error) {
          if (error.message == "Network Error") {
            return Promise.reject({
              success: false,
              message: "网络连接失败",
            });
          } else {
            // 请求已发出，但是不在2xx的范围
            errorHandle(error.status, error.message);
            return Promise.reject({
              success: false,
              error: error,
              message: error.message,
            });
          }
        } else {
          // 处理断网的情况
          // eg:请求超时或断网时，更新state的network状态
          // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
          // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
          // store.commit('changeNetwork', false);
          return Promise.reject({ success: false, message: error });
        }
      }
    );

    return instance.post(
      mUrl + "/xdData/xdDataManage.ashx",
      mActionData,
      mConfig
    );
  }

  getData(url: string, config?: AxiosRequestConfig | undefined) {
    return axios.get(url, config);
  }
}
